
import ApLink from '@/components/APLink.vue'

export default {
  name: 'NoShiptos',
  data() {
    return {
      location: window.location.href
    }
  },
  components: {
    ApLink
  },
  props: {
    company: {
      type: String,
      default: 'AirProducts'
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    portalNoShiptoTranslateId() {
      switch (this.user.salesOrg) {
        case 'GB46':
          return 'ml_133438'
        case 'GB47':
          return 'ml_133440'
        case 'GB49':
          return 'ml_133439'
      }
      return ''
    }
  }
}
